export function getSimpleBlurData(color = '#F0F0F0') {
  const svg = `<svg width="1"
        height="1" xmlns="http://www.w3.org/2000/svg">
        <rect
        width="1" height="1" fill="${color}"/>
        </svg>
    `;
  const base64 = Buffer.from(svg).toString('base64');
  return `data:image/svg+xml;base64,${base64}`;
}
